export default "__VITE_ASSET__D6P616ku__"